import React from "react";
import PropTypes from "prop-types";
import {Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import {APP_TABLE_SETTINGS} from "../../../_constants";
import EditIcon from "@material-ui/icons/Edit";
import TablePaginationActions from "../../_shared/TablePaginationAction";

const PlantList = (props) => {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(APP_TABLE_SETTINGS.DEFAULT_TABLE_PAGE_SIZE);

    React.useEffect( () => {
        if(!!props.data && props.data.length > 0) {
            setPage(0);
        }
    }, [props.data])

    // handle pagination page change event
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    // handle pagination rows per page dropdown change event
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // return factory through props on plant edit action
    const openPlantEdit = (factory) => {
        props.onPlantEditTrigger(true, factory)
    }

    return (
        <TableContainer>
            <Table size="small" stickyHeader aria-label="sticky table"  className={'appTable'}>
                <TableHead>
                    <TableRow>
                        <TableCell>Plant Code</TableCell>
                        <TableCell>Plant Name</TableCell>
                        <TableCell>Factory Code</TableCell>
                        <TableCell>Factory Name</TableCell>
                        <TableCell>Factory</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.isLoading ?  <TableRow><TableCell colSpan={5}> <CircularProgress size={20} /> Loading ...</TableCell></TableRow> : null}
                    {props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        return (
                            <TableRow key={row.factoryId}>
                                <TableCell>{row.plantCode}</TableCell>
                                <TableCell>{row.plantName}</TableCell>
                                <TableCell>{row.factoryCode}</TableCell>
                                <TableCell>{row.factoryName}</TableCell>
                                <TableCell>
                                    <a className="textPrimary" onClick={() => openPlantEdit(row)}>
                                        <EditIcon className="vAlignMiddle" />Edit
                                    </a>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                    {(!props.isLoading && props.data.length == 0) ?  <TableRow><TableCell colSpan={5}> No data found.</TableCell></TableRow> : null}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={APP_TABLE_SETTINGS.DEFAULT_ROWS_PER_PAGE}
                component="div"
                count={props.data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
            />
        </TableContainer>
    )
}

PlantList.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    onPlantEditTrigger: PropTypes.func
}

export default PlantList;
